
export const PriorityColorMap: Record<number, string> = {
    1: 'green',
    2: 'yellow',
    3: 'orange',
    4: 'red'
};

export var DefaultPriorityColor = 'grey';
